import React, { useImperativeHandle, useRef } from 'react';
import { StyleSheet } from 'react-native';
import LottieReact from 'lottie-react';

export const AppLottieView = React.memo(
  React.forwardRef(({ loop = false, autoPlay = true, style, source }: any, ref) => {
    const internalRef = useRef<any>(null);

    useImperativeHandle(ref, () => {
      // Use a Proxy to dynamically intercept and forward ALL calls
      return new Proxy(
        {},
        {
          get(target, prop) {
            // 1. Explicitly polyfill our reset method
            if (prop === 'reset') {
              return () => internalRef.current?.goToAndStop(0, true);
            }

            // 2. Automatically copy and forward all other methods (play, pause, etc.)
            const value = internalRef.current?.[prop];

            // Bind functions to the internal instance to preserve context!
            return typeof value === 'function' ? value.bind(internalRef.current) : value;
          },
        },
      );
    });

    return <LottieReact lottieRef={internalRef} animationData={source} loop={loop} autoplay={autoPlay} style={StyleSheet.flatten(style) as any} />;
  }),
);
